module.exports = __webpack_public_path__ + "img/img-guard-picture-c.dd42d7e2.webp";